export default "__VITE_ASSET__deae8c09__"